(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificate-verification"] && !Shopify.designMode) return;
  try {
    
(function () {
  function draw(root) {
    var box = root.querySelector('[data-cert-qr]');
    var url = root.dataset.verifyUrl;
    if (!box || !url) return;
    var qr = qrcode(0, 'M');            // type 0 = smallest version that fits
    qr.addData(url);
    qr.make();
    box.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
  }

  function init() {
    document.querySelectorAll('[data-ihpso-cert]').forEach(function (root) {
      draw(root);
      var btn = root.querySelector('[data-cert-print]');
      if (btn) btn.addEventListener('click', function () { window.print(); });
    });
  }

  // The library is loaded with defer, so it may or may not be ready when this runs.
  var waited = 0;
  (function ready() {
    if (typeof qrcode === 'function') { init(); return; }
    if (waited > 5000) return;          // give up quietly: the readable address still prints
    waited += 100;
    setTimeout(ready, 100);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["registry-listing"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ihpso-registry]').forEach(function (root) {
    var search  = root.querySelector('[data-registry-search]');
    var list    = root.querySelector('[data-registry-list]');
    if (!list) return;
    var items   = Array.prototype.slice.call(list.querySelectorAll('.ihpso-registry__item'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-registry-filter]'));
    var count   = root.querySelector('[data-registry-count]');
    var none    = root.querySelector('[data-registry-none]');
    var reset   = root.querySelector('[data-registry-reset]');

    function apply() {
      var term = (search && search.value || '').trim().toLowerCase();
      var active = {};
      filters.forEach(function (f) { if (f.value) active[f.dataset.registryFilter] = f.value; });
      var shown = 0;
      items.forEach(function (item) {
        var ok = !term || (item.dataset.search || '').indexOf(term) !== -1;
        if (ok) {
          for (var key in active) {
            if ((item.dataset[key] || '') !== active[key]) { ok = false; break; }
          }
        }
        item.hidden = !ok;
        if (ok) shown++;
      });
      if (count) count.textContent = shown;
      if (none) none.hidden = shown !== 0;
    }

    if (search) search.addEventListener('input', apply);
    filters.forEach(function (f) { f.addEventListener('change', apply); });
    if (reset) reset.addEventListener('click', function () {
      if (search) search.value = '';
      filters.forEach(function (f) { f.value = ''; });
      apply();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
